import React, { useMemo } from 'react'
import BookingTable from './BookingTable';
import { BookingTabsProps, getTravellerCategory } from './bookingUtils';

const BookingTabs = (props: BookingTabsProps) => {

    const { TravelCategoryId, activeTab, setActiveTab,
        BookingList, setBookingList, filteritems, userRights,
        searchvalue, setSearchValue, searchby, setSerachBy, serchdisable, getbookingdatalist,
    } = props;

    const tabs: any = [
        {
            tabId: 2,
            tabName: "Upcoming",
            tabDisplayName: "Upcoming",
            isActive: true
        },
        {
            tabId: 3,
            tabName: "Ongoing",
            tabDisplayName: "Ongoing",
            isActive: TravelCategoryId !== 1 ? true : false
        },
        {
            tabId: 6,
            tabName: "Completed",
            tabDisplayName: "Completed",
            isActive: true
        },
        {
            tabId: 5,
            tabName: "Cancelled",
            tabDisplayName: "Cancelled",
            isActive: true
        },
        {
            tabId: 0,
            tabName: "Failed",
            tabDisplayName: "Failed",
            isActive: true
        },
        {
            tabId: 9,
            tabName: "OnHold",
            tabDisplayName: "On Hold",
            isActive: TravelCategoryId === 5 ? true : false
        },
    ];

    const displayTabName = useMemo(() => {
        return tabs?.find((fin: any) => fin?.tabId === activeTab)?.tabDisplayName;
    }, [activeTab])

    const handleTabSection = (tabId: number) => {
        localStorage.setItem(`tab-${getTravellerCategory(TravelCategoryId)}`, tabId?.toString());
        setActiveTab(tabId);
    }

    return (
        <div>
            <div className="m-2 heading_color">
                <h4> {displayTabName} Bookings </h4>
            </div>
            <div className="p-2">
                <div className='container tab_section px-0 mt-3 mb-5'>
                    <ul className="nav nav-pills nav-justified col-12" id="pills-tab" role="tablist">

                        {
                            tabs?.filter((fil: any) => fil?.isActive)?.map((obj: any) => {
                                return (
                                    <li key={obj?.tabId} className="nav-item mx-2 mb-1" role="presentation">
                                        <button className={`nav-link ${activeTab === obj?.tabId ? "active" : ""}`} id={`pills-${obj?.tabName}-tab`} data-bs-toggle="pill"
                                            data-bs-target={`#pills-${obj?.tabName}`} type="button" role="tab" aria-controls={`pills-${obj?.tabName}`}
                                            aria-selected={activeTab === obj?.tabId ? "true" : "false"}
                                            onClick={() => handleTabSection(obj?.tabId)}
                                        >
                                            <div className='fw-500'> {obj?.tabDisplayName} </div>
                                        </button>
                                    </li>
                                )
                            })
                        }
                    </ul>
                </div>

                <div className="tab-content" id="pills-tabContent">
                    {
                        tabs?.filter((fil: any) => fil?.isActive)?.map((obj: any) => {
                            return (
                                <div key={obj?.tabId} className={`tab-pane fade show ${activeTab === obj?.tabId ? "active" : ""}`} id={`pills-${obj?.tabName}`} role="tabpanel" aria-labelledby={`pills-${obj?.tabName}-tab`}>
                                    <BookingTable
                                        TravelCategoryId={TravelCategoryId}
                                        activeTab={obj?.tabId}
                                        activeTabName={obj?.tabName}
                                        BookingList={BookingList}
                                        setBookingList={setBookingList}
                                        filteritems={filteritems}
                                        userRights={userRights}
                                        searchvalue={searchvalue}
                                        setSearchValue={setSearchValue}
                                        searchby={searchby}
                                        setSerachBy={setSerachBy}
                                        serchdisable={serchdisable}
                                        getbookingdatalist={getbookingdatalist}
                                    />
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    )
}

export default BookingTabs
